module.exports = __webpack_public_path__ + "static/media/img2-3.dd8c7bcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/biosense/diff/img2-3.png
// module id = 1527
// module chunks = 3